import { Role } from './role'
import { Lang } from './lang'

export interface ILoginInfo {
  user_id?: number
  username?: string
  description?: string
  parent_id?: number
  role?: Role
  is_admin?: boolean
  lang?: Lang
  customer?: any
  dealer?: any
  stakeholder?: any
  is_enabled?: boolean
  is_dealer?: boolean
  is_customer?: boolean
  view_price?: boolean
}

export class LoginInfo implements ILoginInfo {

  constructor(loginInfo: ILoginInfo) {
    Object.assign(this, loginInfo)
  }
  user_id: number
  description: string
  username: string
  parent_id: number
  role: Role
  is_admin: boolean
  lang: Lang
  stakeholder: any
  customer: any
  dealer: any
  is_enabled: boolean
  is_dealer: boolean
  is_customer: boolean
  view_price: boolean
}
